import { ITableChartSettings, ITableWidgetDataRow } from '@/pages/Dashboards/Charts/TableChart/tableChart.types.ts'

const generateEmptySettings = (): ITableChartSettings => ({
  title: '',
  equipment: [],
  dataRows: [generateEmptyLine()],
})

const generateEmptyLine = (): ITableWidgetDataRow => ({
  title: '',
  parameterId: null,
})

const tableChartUtils = { generateEmptySettings, generateEmptyLine }
export default tableChartUtils
